import { post, postData } from './http'
import global from '@/api/global'

// export function ap (query) {
//   return http({
//     url: 'zwzhbcps/waybill/selectWaybill',
//     method: 'post',
//     data: query,impDriverStandingBookExcel
//     headers: {
//       'content-type': 'application/json;charset=UTF-8'
//     }
//   })
// }
var name = global.driverName
var crmServer3 = global.crmServer3
var driverNameT = global.driverNameT
// 中厚板获取所属车队
export const selectCustomerList = p => post(name + '/cDriverInfo/ZhbCusterInfo', p)
// 司机查询
export const cDlist = p => post(name + '/cDriverInfo/list', p)
// 司机添加
export const cDadd = p => post(name + '/cDriverInfo/add', p)
// 司机修改
export const cDupdate = p => post(name + '/cDriverInfo/update', p)
// 司机删除
export const cDdelete = p => post(name + '/cDriverInfo/delete', p)
// 车辆查询
export const cVIlist = p => post(name + '/cVehicleInfo/list', p)
// 车辆添加
export const cVIadd = p => post(name + '/cVehicleInfo/add', p)
export const cVIaddD = p => post(name + '/cDriverVehicleRel/addDriverVehicle', p)
// 车辆导入
export const impVehicleInfoExcel = p => post(name + '/cVehicleInfo/impVehicleInfoExcel', p)
// 车辆修改
export const cVIupdate = p => post(name + '/cVehicleInfo/update', p)

// 车辆删除
export const cVIdelete = p => post(name + '/cVehicleInfo/delete', p)
// 车长查询
export const cVLlist = p => post(name + '/cVehicleLong/list', p)
// 车长添加
export const cVLadd = p => post(name + '/cVehicleLong/add', p)
// 车长修改
export const cVLupdate = p => post(name + '/cVehicleLong/update', p)
// 车长删除
export const cVLdelete = p => post(name + '/cVehicleLong/delete', p)
// 车辆类型查询
export const cVTlist = p => post(name + '/cVehicleType/list', p)
// 车辆类型添加
export const cVTadd = p => post(name + '/cVehicleType/add', p)
// 车辆类型修改
export const cVTupdate = p => post(name + '/cVehicleType/update', p)
// 车辆类型删除
export const cVTdelete = p => post(name + '/cVehicleType/delete', p)
// 车辆用途列表
export const cVPlist = p => post(name + '/cVehiclePurpose/list', p)
// 车辆用途添加
export const cVPadd = p => post(name + '/cVehiclePurpose/add', p)
// 车辆用途修改
export const cVPupdate = p => post(name + '/cVehiclePurpose/update', p)
// 车辆用途删除
export const cVPdelete = p => post(name + '/cVehiclePurpose/delete', p)
// 车辆排放标准列表
export const cVElist = p => post(name + '/cVehicleEmissionStandards/list', p)
// 车辆排放标准添加
export const cVEadd = p => post(name + '/cVehicleEmissionStandards/add', p)
// 车辆排放标准修改
export const cVEupdate = p => post(name + '/cVehicleEmissionStandards/update', p)
// 车辆排放标准删除
export const cVEdelete = p => post(name + '/cVehicleEmissionStandards/delete', p)
// 获取车辆信息
export const getCVehicleInfo = p => post(name + '/cVehicleInfo/getCVehicleInfo', p)
// 获取司机信息
export const getCDriverInfo = p => post(name + '/cDriverInfo/getCDriverInfoPC', p)
// 开通账号
export const openAccount = p => post(name + '/cDriverAccount/openAccount', p)
// 车辆台账导入
export const impDriverStandingBookExcel = p => post(name + '/driverStandingBook/impDriverStandingBookExcel', p)
// 车辆台账数据查询
export const getDriverStandingBookPage = p => post(name + '/driverStandingBook/getDriverStandingBookPage', p)
// 所属司机下拉
export const getRelationCustomerFleet = p => post(name + '/cVehicleInfo/getRelationCustomerFleet', p)
// 司机修改
export const detailDriver = p => post(name + '/cDriverInfo/detailDriver', p)
// 添加银行卡
export const CDBadd = p => post(name + '/cDriverBankCard/add', p)
// 修改银行卡
export const CDBupdate = p => post(name + '/cDriverBankCard/update', p)
// 设置默认
export const updateDefault = p => post(name + '/cDriverBankCard/updateDefault', p)
// 银行卡列表
export const CDBlist = p => post(name + '/cDriverBankCard/list', p)
// 银行卡删除
export const CDBdelete = p => post(name + '/cDriverBankCard/delete', p)
// 司机报号列表
export const driverSigninList = p => post(name + '/cDriverInfo/driverSigninList', p)
// 登记车辆列表
export const CVRlist = p => post(name + '/cVehicleRegistration/list', p)
// 登记车辆添加
export const CVRadd = p => post(name + '/cVehicleRegistration/add', p)
// 登记车辆修改
export const CVRupdate = p => post(name + '/cVehicleRegistration/update', p)
// 登记车辆删除
export const CVRdelete = p => post(name + '/cVehicleRegistration/delete', p)
// 登记车辆导入
export const RimpVehicleInfoExcel = p => post(name + '/cVehicleRegistration/impVehicleInfoExcel', p)

// -----------司机导入-------
export const impVehicleInfoExcelDrive = p => post(name + '/cDriverInfo/impDriverInfoExcel', p)
// 厂内用车项目需要  新增页面新加机型/吨位下拉框
export const listByTypeId = (typeId) => post(name + `/type2link/listByTypeId/${typeId}`)

// 图片转base64
export const urlChangeBase64 = p => post(name + '/driverStandingBook/urlChangeBase64', p)
// 非道路机械台账页面接口
export const noroadinfoList = p => post(name + '/vehicle/noroadinfo/list', p)
export const noroadinfoAdd = p => post(name + '/vehicle/noroadinfo/add', p)
export const noroadinfoUpdate = p => post(name + '/vehicle/noroadinfo/update', p)
export const noroadinfoDelete = p => post(name + '/vehicle/noroadinfo/delete', p)
// 场内车辆管理
export const insideinfoList = p => post(name + '/vehicle/insideinfo/list', p)
export const insideinfoAdd = p => post(name + '/vehicle/insideinfo/add', p)
export const insideinfoUpdate = p => post(name + '/vehicle/insideinfo/update', p)
export const insideinfoDelete = p => post(name + '/vehicle/insideinfo/delete', p)
// 台账统计-拉运统计
export const driverStandingBookList = p => post(name + '/driverStandingBook/driverStandingBookList', p)
// 台账统计(钱)
export const monthlyStatisticsList = p => post(name + '/driverStandingBook/monthlyStatisticsList', p)

// 台账预警
export const warningList = (p) => post(name + '/warning/list', p)
export const warningListExport = (p) => post(name + '/warning/exportlist', p)
export const warningDelete = (p) => post(name + '/warning/delete', p)
export const warningUpdate = (p) => post(name + '/warning/update', p)
// 黑名单管理
export const hmdAdd = (p) => post(name + '/hmd/add', p)
export const hmdDelete = (p) => post(name + '/hmd/delete', p)
export const hmdList = (p) => post(name + '/hmd/list', p)
// -----扫码登记------
// 登记
export const visitauditAdd = (p) => post(name + '/visitaudit/add', p)
// 登记查询
export const visitauditList = (p) => post(driverNameT + '/visitaudit/list', p)
// 登记审批通过
export const visitauditListPass = (p) => post(name + '/visitaudit/passaudit', p)
// 登记审批驳回
export const visitauditBackaudit = (p) => post(name + '/visitaudit/backaudit', p)
// 获取部门
export const getDepartmentByTenantCode = (p) => post(crmServer3 + '/api/getDepartmentByTenantCode', p)
// 登记查看行驶证
export const visitauditDetail = (p) => post(name + '/visitaudit/detail', p)
// 司机绑定承运商
export const driverBindCustomer = (p) => post(name + '/cDriverInfo/driverBindCustomer', p)

// 车辆监控
export const findVehicleByClassify = (p) => post(name + '/cVehicleInfo/findVehicleByClassify', p)// 查询自家车辆列表
export const vehiclePositionInfo = (p) => post(name + '/cVehicleInfo/vehiclePositionInfo', p)// 查询某一辆车的详情行驶信息
export const vhcHisList = (p) => post(name + '/cVehicleInfo/vhcHisList', p)// 车辆历史轨迹及列表查询

// ICC查询车辆进出记录
export const findHis = (p) => post(driverNameT + '/visitaudit/findHis', p)
// ICC查询车辆进出总数
export const findHisCount = (p) => post(driverNameT + '/visitaudit/findHisCount', p)
